import { motion } from "framer-motion";

const FAQ = () => {
  const faqItems = [
    {
      id: "01",
      question: "Site üyeliği için ücret talep ediliyor mu?",
      answer:
        "Hayır, üyelik tamamen ücretsizdir. Kolektif Oluşum, genç arkadaşlarımızın gelişimine ve Networküne katkıda bulunmayı ve topluluk içinde dayanışmayı artırmayı amaçladığı için herhangi bir üyelik ücreti talep etmemektedir.",
    },
    {
      id: "02",
      question: "Siteye üye olarak hangi avantajlardan yararlanabilirim?",
      answer:
        "Üye olarak, yıl boyunca ücretsiz düzenlenen özel etkinliklere, atölyelere ve sosyal sorumluluk projelerine katılma hakkı kazanırsınız.",
    },
    {
      id: "03",
      question: "Kolektif Oluşum'a nasıl üye olabilirim?",
      answer:
        "Sağ üst köşede bulunan 'Üye Ol' butonuna tıklayarak hemen üye olabilirsiniz. Üyelik işlemi sadece birkaç saniye sürmektedir.",
    },
    {
      id: "04",
      question: "Diğer okullardaki öğrencilerle nasıl iletişim kurabilirim?",
      answer:
        "Oluşumumuz, farklı okullardaki öğrencilerin bir araya gelmesini sağlayan çeşitli networking etkinlikleri düzenlemektedir. Bu etkinlikler sayesinde diğer okullardaki öğrencilerle tanışabilir, ortak projeler geliştirebilir ve geniş bir Network ağı oluşturabilirsiniz. Ayrıca, oluşumun mobil uygulamasında diğer üyelerle iletişim kurma ve deneyimlerinizi paylaşma imkanınız olacak.",
    },
    {
      id: "05",
      question: "Kolektif Oluşum içinde aktif rol alabilir miyim?",
      answer:
        "Kesinlikle! Oluşumumuz, öğrencilerin aktif katılımını teşvik eder. Okulunuzdaki veya oluşum içindeki organizasyon komitelerinde görev alabilir, projeler ve etkinlikler için önerilerde bulunabilir ve liderlik becerilerinizi geliştirebilirsiniz. Aktif ve hevesli arkadaşlarımız, oluşumumuzun başarısında büyük rol oynamaktadır.",
    },
    {
      id: "06",
      question: "Etkinliklere katılmak için nasıl kayıt yaptırabilirim?",
      answer:
        "Siteye üye olduktan sonra, etkinlikler ve atölyeler hakkında bilgilendirmeler e-posta yoluyla ve sosyal medya kanallarımız üzerinden paylaşılacaktır. Ayrıca, üyelik platformumuzda etkinlik takvimine erişebilir ve katılmak istediğiniz yaklaşan etkinlikler için kayıt yaptırabilirsiniz.",
    },
    {
      id: "07",
      question:
        "Benim okulumda Kolektif, Öğrenci Birliği Seçimlerini kazandı. Kolektifli olmam ne gibi farklılıklar sağlayacak?",
      answer:
        "Okullarda Öğrenci Birliği seçimlerine girmemizin sebebi elimizdeki geniş imkanları gençler için daha büyük çapta kullanma fırsatı sağlamak. Okulunuzda Kolektif, Öğrenci Birliği kabinesi olarak bulunuyorsa o okuldaki öğrencilere hizmet etme vizyonuyla hareket eder. Siz üye olarak işin detaylarına inebilir, farklı insanlarla daha derin Networkler oluşturabilir, okulunuzdaki icraatlere destek verebilir ve en önemlisi liderlik ve organizasyon becerilerinizi şahane bir şekilde geliştirebilirsiniz.",
    },
    {
      id: "08",
      question: "Yaş sınırı var mı?",
      answer:
        "Kolektif Oluşum'a dahil olmak için liseye geçmiş olmak yeterli. Lise seviyesinden sonra her yaştan öğrenci, sunduğumuz tüm imkanlardan faydalanabilir. Öğrenciler, lise düzeyinden üniversiteyi bitirene kadar geniş bir yelpazede oluşumumuzun etkinliklerine ve projelerine katılabilirler.",
    },
  ];

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-32 pb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-[40px] font-bold text-white mb-4">
              Sıkça Sorulan Sorular
            </h1>
            <p className="text-xl text-gray-400">
              Kolektif Oluşum hakkında merak edilenler
            </p>
          </motion.div>

          <div className="max-w-3xl mx-auto space-y-6">
            {faqItems.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{
                  scale: 1.02,
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                  transition: { duration: 0.2 },
                }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white/5 backdrop-blur-lg rounded-2xl p-6 border border-white/10 hover:border-blue-500/30 transform-gpu will-change-transform cursor-pointer"
              >
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <motion.span
                      className="inline-flex items-center justify-center h-8 w-8 rounded-lg bg-blue-500/10 text-blue-400 text-sm font-medium border border-blue-500/20"
                      whileHover={{
                        scale: 1.1,
                        backgroundColor: "rgba(59, 130, 246, 0.2)",
                        transition: { duration: 0.2 },
                      }}
                    >
                      {item.id}
                    </motion.span>
                  </div>
                  <div>
                    <motion.h2
                      className="text-xl font-semibold text-white mb-3"
                      whileHover={{ x: 2 }}
                    >
                      {item.question}
                    </motion.h2>
                    <p className="text-gray-400 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default FAQ;
